<template>
  <div class="popup-container" id="popup-container">
    <v-toolbar dark color="primary">
      <v-toolbar-title class="heading-title"> Edit user </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab x-small class="close" @click="closePanel">
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container class="assetbar">
      <v-layout>
        <v-flex xs12>
          <v-card flat>
            <v-form>
              <v-text-field
                :error-messages="messages.first_name"
                v-model="user.first_name"
                label="First Name"
                type="text"
                filled
                class="input-width"
              ></v-text-field>
              <v-text-field
                :error-messages="messages.last_name"
                v-model="user.last_name"
                label="Last Name"
                type="text"
                filled
                class="input-width"
              ></v-text-field>
              <v-text-field
                :error-messages="messages.email"
                v-model="user.email"
                label="Email"
                type="text"
                filled
                class="input-width"
              ></v-text-field>
              <v-text-field
                v-if="id === this.$store.getters.user.id"
                :error-messages="messages.password"
                v-model="user.password"
                label="Re-set password"
                type="password"
                filled
                class="edit-input-width"
              >
                <template slot="append-outer">
                  <v-tooltip left>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on">fa fa-question</v-icon>
                    </template>
                    <span
                      >The re-set password must be at least 8 characters,
                      contain 1 uppercase, 1 lowercase & 1 special
                      Charecter.</span
                    >
                  </v-tooltip>
                </template>
              </v-text-field>
              <v-text-field
                v-if="id === this.$store.getters.user.id"
                v-model="user.confirm_password"
                :error-messages="messages.confirm_password"
                label="Confirm re-set password"
                type="password"
                filled
                class="edit-input-width"
              >
                <template slot="append-outer">
                  <v-tooltip left>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on">fa fa-question</v-icon>
                    </template>
                    <span
                      >The confirm re-set password must be same as
                      password.</span
                    >
                  </v-tooltip>
                </template>
              </v-text-field>              
              <v-select
                v-model="user.role_id"
                :items="roles"
                item-text="name"
                item-value="id"
                label="Access Level"
                hint="Change User Privileges"
                filled
                attach
                @change="getAllUsers(user.role_id)"
                v-if="roleCheck"
              >
                <template slot="append-outer">
                  <v-tooltip left>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on">fa fa-question</v-icon>
                    </template>
                    <span>Change User Privileges</span>
                  </v-tooltip>
                </template>
              </v-select>
              <v-autocomplete
                v-model="user.assigned_users"
                :items="users"
                filled
                chips
                label="Please select all of the team members of the user you're creating"
                item-text="first_name"
                item-value="id"
                multiple
                v-if="isUserList"
                :item-disabled="isDisabled"
              >
                <template v-slot:selection="data">
                  <v-chip
                    v-bind="data.attrs"
                    :input-value="data.selected"
                    close
                    @click="data.select"
                    @click:close="remove(data.item)"
                  >
                    {{ data.item.first_name + ' ' + data.item.last_name }}
                  </v-chip>
                </template>
                <template v-slot:item="data">
                  <template v-if="typeof data.item !== 'object'">
                    <v-list-item-content
                      v-text="data.item"
                    ></v-list-item-content>
                  </template>
                  <template v-else>
                    <v-list-item-content>
                      <v-list-item-title
                        v-html="
                          data.item.first_name + ' ' + data.item.last_name
                        "
                      ></v-list-item-title>
                    </v-list-item-content>
                  </template>
                </template>
              </v-autocomplete>
              <v-select v-if="this.locations.length" v-model="user.site_id" :items="filteredLocations" :filter="customFilter" :clearable="true" @change="resetSearchTerm"
                item-text="name" item-value="id" :label="$globalConfig.APP_NAME === 'senso' ? 'Sites' : 'Locations'" :hint="$globalConfig.APP_NAME === 'senso' ? 'Select user site' : 'Select user location'" persistent-hint filled multiple small-chips>
                <template slot="append-outer">
                  <v-tooltip left>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on">fa fa-question</v-icon>
                    </template>
                    <span>Select user {{ $globalConfig.APP_NAME === 'senso' ? 'site' : 'location'}}</span>
                  </v-tooltip>
                </template>
                <template v-slot:prepend-item>
                <v-list-item>
                  <v-list-item-content style="padding: 12px 0 0 0;">
                    <v-text-field v-model="searchTerm"
                      :label="$globalConfig.APP_NAME === 'senso' ? 'Search Site' : 'Search Location'"
                      @input="onSearchInput" class="search-term location-search" style="margin:0;"></v-text-field>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
              </template>
              </v-select>
              <v-switch v-model="isMailSent" class="input_switch mb-5">
                <template v-slot:label>
                  <div>
                    <strong class="grey800--text">Reset welcome email</strong>
                  </div>
                  <div class="ml-5">
                    <v-tooltip left>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on">fa fa-question</v-icon>
                      </template>
                      <span
                        >Toggle this on to reset this User a welcome
                        email.</span
                      >
                    </v-tooltip>
                  </div>
                </template>
              </v-switch>
            </v-form>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-footer absolute style="height: auto">
      <v-flex text-right>
        <v-btn
          v-if="!loading"
          color="grey300"
          class="mr-4 cancel-button"
          @click="closePanel"
          >Cancel</v-btn
        >
        <v-btn v-if="loading" color="primary" loading></v-btn>
        <v-btn
          v-else
          color="dark-blue"
          class="add-course-button"
          @click="updateUser"
          >Save</v-btn
        >
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import { EventBus } from '@/event-bus.js';
import userAPI from '@/api/user.js';
import companyAPI from '@/api/company.js';

export default {
  name: 'Edituser',
  props: {
    id: {
      type: String,
      default: null,
    },
    params: {
      type: String,
      default: null,
    },
    locations: {
      type: Array,
      default: null
    },
  },
  data() {
    return {
      messages: {},
      roles: [
        {
          name: 'User',
          id: 3,
        },
        {
          name: 'Administrator',
          id: 2,
        },
        {
          name: 'Team Manager',
          id: this.$globalConfig.APP_NAME == 'direct' ? 4 : 7,
        },
      ],
      user: {},
      valid: true,
      successMessage: 'User Successfully Updated.',
      updateroleinfo:
        "User Successfully Updated, You can't change role of admin user as they were created by partner or logged in admin account",
      errorMessage:
        'Oops, something went wrong! Please check information is correct.',
      changeRole:
        'Are you sure you want to change users role. Updating to administrator will remove your administrator access.',
      loading: false,
      users: [],
      isUserList: false,
      assigned: [],
      searchTerm : "",
      locationsCopy : [...this.locations],
    };
  },
  mounted() {
    this.getUser(this.id);
  },
  computed: {
    isMailSent: {
      get() {
        return !this.user.is_mail_sent
      },
      set(newValue) {
        this.user.is_mail_sent = newValue
      }
    },
    roleCheck() {
      if (this.$globalConfig.APP_NAME == 'direct') {
        return this.$store.state.auth.user.role_id !== 4;
      } else if (this.$globalConfig.APP_NAME === 'senso' || this.$globalConfig.APP_NAME === 'partner') {
        return this.$store.state.auth.user.role_id !== 7;
      }
      return false; // Default fallback
    },
    filteredLocations() {
      if (!this.searchTerm) {
        return this.locationsCopy; // Return the original list if search is empty
      }
      return this.locationsCopy.filter((location) =>
        location.name.toLowerCase().includes(this.searchTerm.toLowerCase())
      );
    },
  },
  methods: {
    closePanel() {
      this.$emit('closePanel', {});
    },
    contine(toast) {
      this.$snotify.remove(toast.id);
    },
    getUser(id) {
      userAPI.getUser(id, '?include=groups').then((response) => {
        this.user = response.data.data;
        this.user.site_id = this.user.site_id;
        var a = [];
        this.user.groups.data.forEach(function (x) {
          a.push(x.id);
        });
        this.user.groups = a;
        if (this.user.role_id == 7 || this.user.role_id == 4) {
          this.getAllUsers(this.user.role_id);
          this.getManagerUsers(this.id);
        }
      });
    },
    updateUser() {
      this.loading = true;
      userAPI
        .updateUser(this.id, this.user)
        .then((response) => {
          if(this.$store.getters.user.id == this.id)
              this.$store.dispatch('profile');
          this.closePanel();
          if (this.$store.getters.teamManager) {
            EventBus.$emit('TEAM_COURSES_UPDATED', this.params);
          }else{
            EventBus.$emit('USERS_UPDATED', this.params);
          }
          if (response.data.data.update_role_error) {
            this.$snotify.error(this.updateroleinfo);
          } else {
            this.$snotify.success(this.successMessage);
          }
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        })
        .catch((err) => {
          this.loading = false;
          this.valid = false;
          this.messages = this.$gf.errorResponse(err);
          this.$snotify.error(this.errorMessage);
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    },
    getAllUsers(id) {
      if (id == 7 || id == 4) {
        this.isUserList = true;
        userAPI.getAllUsers().then((response) => {
          this.users = response.data.data;
        });
      }else{
        this.isUserList = false;
      }
    },
    remove(item) {
      const index = this.user.assigned_users.indexOf(item.id);
      if (index >= 0) this.user.assigned_users.splice(index, 1);
    },
    getManagerUsers(id) {
      userAPI.getManagerUsers(id).then((response) => {
        var a = [];
        response.data.data.forEach(function (x) {
          a.push(x.user_id);
        });
        this.user.assigned_users = a;
        this.assigned = a;
      });
    },
    customFilter(item, search) {
      // This can be customized as needed for advanced filtering
      return item.name.toLowerCase().includes(search.toLowerCase());
    },
    onSearchInput() {
      // The computed property will handle the filtered list dynamically
    },
    resetSearchTerm() {
        this.searchTerm = ""; // Clear the search term
    },
     isDisabled(item) {
      return this.id == item.id;
    }
  },
};
</script>
<style>
.assetbar {
  height: calc(100% - 100px);
  overflow-y: scroll;
}

.popup-container {
  height: 100%;
}
.location-search input{
  border-bottom: 1px solid;
}
</style>